<template>
  <div class="customerAddress" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.customerAddress.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('地址', 'Address') }}
        </el-text>
        <el-button-group>
          <el-button @click="goback()">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.customerAddress.id">
        <el-input v-model="data.customerAddress.id" disabled />
      </el-form-item>
      <el-form-item :label="util.language('联系人', 'Contact')">
        <el-input v-model="data.customerAddress.contact" />
      </el-form-item>
      <el-form-item label=" ">
        <el-collapse v-model="show.usingGoogleMap" style="width: 100%;" name="googleMap">
          <el-collapse-item :title="util.language('使用Google地图选择地点信息', 'Use Google Map to select location information')">
            <div>
              <el-input v-model="data.mapKeyWord" :placeholder="util.language('输入地址关键字搜索', 'Enter address keyword to search')" style="width:calc(100% - 100px);" />
              <el-button @click="searchPlace" type="primary" style="margin-left: 20px; width: 80px;">{{ util.language('搜索', 'Search') }}</el-button>
              <el-table :data="show.placeList" style="width: 100%;" max-height='130px' :show-header="false" size="small">
                <el-table-column prop="name" width="300" show-overflow-tooltip />
                <el-table-column prop="formattedAddress" show-overflow-tooltip />
                <el-table-column width="80" aline="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-link @click="clickPlace(scope.row)" type="primary" size="small">{{ util.language('选择', 'Select') }}</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div id="map" style="width: 100%;height: 300px;margin-top: 2px;"></div>
            <div style="margin-top: 20px;" v-if="show.placeInfo">
              <el-text style="margin-right: 20px;">{{ util.language('名称：', 'Name: ') }}</el-text>
              <el-text>{{ show.placeInfo.name }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('地址：', 'Address: ') }}</el-text>
              <el-text>{{ show.placeInfo.formattedAddress }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('坐标：', 'Coordinates: ') }}</el-text>
              <el-text>{{ show.placeInfo.lat }}, {{ show.placeInfo.lng }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('电话：', 'Phone: ') }}</el-text>
              <el-text>{{ show.placeInfo.phone }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('营业时间：', 'Opening Hours: ') }}</el-text>
              <el-text>{{ show.placeInfo.openingHours }}</el-text>
              <br />
              <el-button type="primary" size="small" @click="confirmPlace">{{ util.language('确认，并快速填写', 'Confirm and fill in quickly') }}</el-button>
              <el-button size="small" @click="show.usingGoogleMap = []">{{ util.language('关起', 'Close') }}</el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
      <el-form-item :label="util.language('电话号', 'Phone')">
        <el-input v-model="data.customerAddress.phone" />
      </el-form-item>
      <el-form-item :label="util.language('Google地点ID', 'Google Place ID')">
        <el-tooltip :content="util.language('请在地图中搜索并选择点位，不可直接编辑', 'Please search and select the point in the map, do not edit directly')" placement="top">
          <el-input v-model="data.customerAddress.googlePlaceId" style="width: 40%;" disabled />
        </el-tooltip>
        <el-input v-model="data.customerAddress.lat" style="width: 25%;margin-left: 5%;" disabled />
        <el-input v-model="data.customerAddress.lng" style="width: 25%;margin-left: 5%;" disabled />
      </el-form-item>
      <el-form-item :label="util.language('营业时间', 'Opening Hours')">
        <template v-if="data.customerAddress && data.customerAddress.openingHours">
          <div style="width: 100%;" v-for="openingHoursItem, index in data.customerAddress.openingHours.split(',')" :key="index">
            <el-text>{{ openingHoursItem }}</el-text>
          </div>
        </template>
      </el-form-item>
      <el-form-item :label="util.language('详细地址', 'Address')">
        <el-input v-model="data.customerAddress.addressDetail" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import { Loader } from '@googlemaps/js-api-loader'

const router = useRouter()
const loading = reactive({
  save: false,
})
const show = reactive({
  usingGoogleMap: [],
  placeList: [], // 地点搜索结果
  placeInfo: null, // 地点信息
})
const pageParam = cache.getObject(cache.keys.pageParam + "customerAddress")
const data = reactive({
  customerAddress: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  mapKeyWord: '', // 谷歌地图搜索关键词
})

const mapLoader = new Loader({
  apiKey: 'AIzaSyBi5KgsssFebf3i05F_llpS8poRAnHXXpU',
  libraries: ['places'],
});

/** 搜索地址 */
const searchPlace = () => {
  const params = {
    keyWord: data.mapKeyWord
  }
  api.get('/backend/map/byKeyword', { params }).then(res => {
    if (res.list.length === 0) {
      ElMessage.warning(util.language('没查询到位置', 'No location found'))
    }
    show.placeList = res.list
  })
}

/** 选中一个地址 */
const clickPlace = (place) => {
  data.map.setCenter({ lat: place.lat, lng: place.lng })
  data.map.setZoom(18)
  if (!place.phone) {
    api.get('/backend/map/byId', { params: { placeId: place.placeId } }).then(res => {
      place.openingHours = res.openingHours
      place.phone = res.phone
      show.placeInfo = place
    })
  } else {
    show.placeInfo = place
  }
}

/** 确认选择的地址 */
const confirmPlace = () => {
  data.customerAddress.phone = show.placeInfo.phone
  data.customerAddress.addressDetail = show.placeInfo.formattedAddress
  data.customerAddress.googlePlaceId = show.placeInfo.placeId
  data.customerAddress.lat = show.placeInfo.lat
  data.customerAddress.lng = show.placeInfo.lng
  data.customerAddress.openingHours = show.placeInfo.openingHours
}

const save = () => {
  loading.save = true
  if (!data.customerAddress.id) {
    api.post('/backend/customer/addCustomerAddress', {
      customerId: data.customerAddress.customerId,
      contact: data.customerAddress.contact,
      phone: data.customerAddress.phone,
      googlePlaceId: data.customerAddress.googlePlaceId || '',
      lat: data.customerAddress.lat,
      lng: data.customerAddress.lng,
      openingHours: data.customerAddress.openingHours || '',
      addressDetail: data.customerAddress.addressDetail,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      goback()
    }).finally(() => {
      loading.save = false
    })
  } else {
    api.post('/backend/customer/setCustomerAddress', {
      id: data.customerAddress.id,
      contact: data.customerAddress.contact,
      phone: data.customerAddress.phone,
      googlePlaceId: data.customerAddress.googlePlaceId || '',
      lat: data.customerAddress.lat,
      lng: data.customerAddress.lng,
      openingHours: data.customerAddress.openingHours || '',
      addressDetail: data.customerAddress.addressDetail,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      goback()
    }).finally(() => {
      loading.save = false
    })
  }
}

const goback = () => {
  if (window.history.length > 1) {
    router.go(-1)
  } else {
    window.close();
  }
}

onMounted(() => {
  mapLoader.importLibrary('maps').then(mapsLoader => {
    // 初始化MAP
    data.map = new mapsLoader.Map(document.getElementById('map'), {
      center: { lat: 43.70, lng: -79.4 },
      zoom: 11,
      mapId: 'b0129775b4e1462ad56c1bf4',
      mapTypeControl: false, // 禁用地图模式切换按钮
    })
  })
})
</script>

<style lang="less">
.customerAddress {
  margin: auto;
  max-width: 900px;
}
</style>